import React from 'react';

function JointCommission(props) {
  if (props.isHomePage) {
    return (
      <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '14px'}}>
          <img style={{width: '200px'}} src={require("../img/joint_commission.jpg")} alt="joint_commission" />
      </div>
    );
  } else {
    return (
      <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '14px', border: '#ced4da 1px solid'}}>
          <img style={{width: '250px', margin: '35px 0'}} src={require("../img/joint_commission.jpg")} alt="joint_commission" />
      </div>
    );
  }
}

export default JointCommission;